<template>
  <div class="common-page">
    <div class="common-body flexCenter dflex error-page-body">
      <div class="error-page-change-l-body" v-if="UAParserCheckError">
        <select class="error-page-change-select" v-model="locale">
          <option :value="item.code" v-for="(item, index) in langList">{{
            item.label
          }}</option>
        </select>
      </div>

      <div>
        <img src="/img/tipsIcon.png" width="48" height="48" />
      </div>
      <div class="error-page-title" v-if="!UAParserCheckError">
        {{ $t('m.errorTip') }}
      </div>
      <div class="error-page-title tc" v-else>
        <template v-if="ticketUAParserCheckError">
          <div class="whiteSpace">{{ $t('m.uaCheckErrorTitle2') }}</div>
        </template>
        <template v-else>
          {{ $t('m.uaCheckErrorTitle') }}
        </template>
      </div>
      <template v-if="!UAParserCheckError">
        <div class="error-page-text" v-for="(item, index) in errorData">
          {{ item }}
        </div>
      </template>
      <template v-else>
        <div class="error-page-text">
          <template v-if="ticketUAParserCheckError">
            <div class="f16 mb20 mt20 cWhite">
              {{ $t('m.uaCheckErrorTip2') }}<br />
            </div>
          </template>
          <template v-else>
            <div class="f16 mb20 mt20">
              {{ $t('m.uaCheckErrorTip') }}<br />
              <span @click="copy" class="error-page-text word-break pointer">{{
                url
              }}</span>
            </div>
          </template>

          <!-- 设备信息显示部分 -->
          <div v-if="deviceInfo" class="device-info-container">
            <div class="device-info-title">
              {{ $t('m.devicePageErrorDeviceInfo') }}
            </div>
            <div class="device-info-item" v-if="deviceInfo.os">
              <span class="device-info-label"
                >{{ $t('m.devicePageErrorOsInfo') }}:</span
              >
              <span class="device-info-value"
                >{{ deviceInfo.os.name }} {{ deviceInfo.os.version }}</span
              >
            </div>
            <div class="device-info-item" v-if="deviceInfo.browser">
              <span class="device-info-label"
                >{{ $t('m.devicePageErrorBrowserInfo') }}:</span
              >
              <span class="device-info-value"
                >{{ deviceInfo.browser.name }}
                {{ deviceInfo.browser.version }}</span
              >
            </div>
          </div>

          <div>
            {{
              `${$t('m.devicePageErrorTip3')}\n■${$t(
                'm.devicePageErrorTip4'
              )}\n${$t('m.devicePageErrorTip5')}\n■${$t(
                'm.devicePageErrorTip6'
              )}\n\n■${$t('m.devicePageErrorTip7')}\n${$t(
                'm.devicePageErrorTip8'
              )}\n${$t('m.devicePageErrorTip9')}\n\n■${$t(
                'm.devicePageErrorTip10'
              )}\n${$t('m.devicePageErrorTip11')}\n${$t(
                'm.devicePageErrorTip12'
              )}\n${$t('m.devicePageErrorTip13')}`
            }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, inject, watch } from '@vue/runtime-core'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { langList, copyToClipboard } from '@/utils/utils'
import store from '@/store'

export default {
  props: {
    UAParserCheckError: {
      type: Boolean,
      default: false,
    },
    ticketUAParserCheckError: {
      type: Boolean,
      default: false,
    },
    deviceInfo: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()

    const toast = inject('toast')

    const { t, locale } = useI18n()
    watch(locale, (val) => {
      localStorage.setItem('locale', val)
    })

    const url = ref('')
    const getUrl = () => {
      url.value = window.location.href
    }
    watch(
      () => route,
      (val) => {
        getUrl()
      },
      { immediate: true }
    )

    const copy = () => {
      copyToClipboard(url.value)
        .then(() => {
          toast.success(t('m.copySuccess'), {
            position: 'top',
          })
        })
        .catch(() => {
          toast.error(t('m.copyError'), {
            position: 'top',
          })
        })
    }
    onMounted(() => {
      getUrl()
    })
    return {
      langList,
      locale,
      url,
      copy,
    }
  },
}
</script>

<style lang="less" scoped>
.error-page-body {
  min-height: 100%;
  flex-direction: column;
}
.error-page-title {
  font-size: 18px;
  color: #fff;
  margin: 14px 0 10px 0;
}
.error-page-text {
  font-size: 14px;
  line-height: 18px;
  white-space: pre-wrap;
  color: #8a8a8a;
}

.error-page-change-l-body {
  position: absolute;
  right: 15px;
  top: 15px;
}
.error-page-change-select {
  border: 1px solid #ced0d4;
  color: #fff;
  box-sizing: border-box;
  border-radius: 3px;
  background: rgba(138, 138, 138, 0.3);
  padding: 6px 10px;
}
.error-page-change-select option {
  background: rgb(0, 0, 0);
  color: #fff;
}
.error-page-select-subtitle-select {
  border: 1px solid #ced0d4;
  color: #fff;
  box-sizing: border-box;
  border-radius: 3px;
  background: rgba(138, 138, 138, 0.3);
  padding: 6px 10px;
  width: 100%;
}
.error-page-select-subtitle-select option {
  background: rgb(0, 0, 0);
  color: #fff;
}

.device-info-container {
  margin: 15px 0;
  padding: 10px;
  border-radius: 5px;
  background: rgba(60, 60, 60, 0.5);
  max-width: 90%;
}

.device-info-title {
  font-size: 14px;
  color: #fff;
  margin-bottom: 10px;
  font-weight: 500;
}

.device-info-item {
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
}

.device-info-label {
  color: #aaa;
  min-width: 70px;
  margin-right: 8px;
}

.device-info-value {
  color: #fff;
}
</style>
